/* eslint-disable @typescript-eslint/naming-convention */

import createSvgIcon from '../Utils/CreateSvgIcon';

export const ISOFix = createSvgIcon(
  <path
    d="M10 12V14H12H19.748C18.8599 17.4505 15.7277 20 12 20C7.58172 20 4 16.4183 4 12C4 8.27232 6.54955 5.14012 10 4.25203L10 12ZM22 12C22 12.6849 21.9311 13.3538 21.8 14C20.8734 18.5645 16.8379 22 12 22C6.47715 22 2 17.5228 2 12C2 7.16208 5.43552 3.12658 10 2.20004C10.6462 2.06886 11.3151 2 12 2V4L12 10V12H14H20H22ZM15 9L21 9L21 7L15 7V9Z"
    fillRule="evenodd"
  />,
  'ISOFix',
);
